import React, { useState } from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import surveyUtils from '../../utils/survey';
import Title from '../../components/title-tile/titleTileComponent';

let errorArray = [];

const SurveyForm = () => {
  const [error, setError] = useState(null);
  const [description, setDescription] = useState('');
  const [errorDescription, setErrorDescription] = useState(null);
  const [dateFrom, setDateFrom] = useState('');
  const [errorDateFrom, setErrorDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState('');
  const [errorDateTo, setErrorDateTo] = useState(null);
  const [status, setStatus] = useState('');
  const [errorStatus, setErrorStatus] = useState(null);
  const [url, setUrl] = useState('');
  const [errorUrl, setErrorUrl] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [success, setSuccess] = useState(false);

  const clearError = (validation) => {
    errorArray = errorArray.filter((elem) => elem !== validation);
  };

  const handleDescription = (e) => {
    const value = e.target.value;
    const validation = 'La descripción no puede estar vacía.\n';
    if (value) {
      setDescription(value);
      setErrorDescription(null);
      clearError(validation);
    } else {
      if (!errorArray.includes(validation)) errorArray.push(validation);
      setErrorDescription(validation);
    }
  };

  const handleDateFrom = (e) => {
    const value = e.target.value;
    const validation = 'La fecha de inicio debe ser válida.\n';
    setDateFrom(value);
    if (value) {
      setErrorDateFrom(null);
      clearError(validation);
      // Cross-date validation
      if (dateTo && value > dateTo) {
        const crossValidation = 'La fecha de inicio debe ser anterior a la fecha de fin.\n';
        setErrorDateFrom(crossValidation);
        if (!errorArray.includes(crossValidation)) errorArray.push(crossValidation);
      } else {
        clearError('La fecha de inicio debe ser anterior a la fecha de fin.\n');
      }
    } else {
      if (!errorArray.includes(validation)) errorArray.push(validation);
      setErrorDateFrom(validation);
    }
  };

  const handleDateTo = (e) => {
    const value = e.target.value;
    const validation = 'La fecha de fin debe ser válida.\n';
    setDateTo(value);
    if (value) {
      setErrorDateTo(null);
      clearError(validation);
      // Cross-date validation
      if (dateFrom && value < dateFrom) {
        const crossValidation = 'La fecha de inicio debe ser anterior a la fecha de fin.\n';
        setErrorDateTo(crossValidation);
        if (!errorArray.includes(crossValidation)) errorArray.push(crossValidation);
      } else {
        clearError('La fecha de inicio debe ser anterior a la fecha de fin.\n');
      }
    } else {
      if (!errorArray.includes(validation)) errorArray.push(validation);
      setErrorDateTo(validation);
    }
  };

  const handleStatus = (e) => {
    const value = e.target.value;
    const validation = 'El estado no puede estar vacío.\n';
    setStatus(value);
    if (value) {
      setErrorStatus(null);
      clearError(validation);
    } else {
      if (!errorArray.includes(validation)) errorArray.push(validation);
      setErrorStatus(validation);
    }
  };

  const handleUrl = (e) => {
    const value = e.target.value;
    setUrl(value);
    setErrorUrl(null);
    clearError('El link no puede estar vacío.\n');
  };

  const saveSurvey = () => {
    // Validate required fields
    if (!description) handleDescription({ target: { value: '' } });
    if (!dateFrom) handleDateFrom({ target: { value: '' } });
    if (!dateTo) handleDateTo({ target: { value: '' } });
    if (!status) handleStatus({ target: { value: '' } });

    // Cross-date validation
    if (dateFrom && dateTo && dateFrom > dateTo) {
      const crossValidation = 'La fecha de inicio debe ser anterior a la fecha de fin.\n';
      if (!errorArray.includes(crossValidation)) errorArray.push(crossValidation);
      setErrorDateFrom(crossValidation);
      setErrorDateTo(crossValidation);
    }

    if (errorArray.length > 0) {
      setError(errorArray);
      return;
    }
    setDisabled(true);
    setError([]);
    const surveyData = {
      description,
      dateFrom,
      dateTo,
      status,
      url,
    };
    console.log('Creating survey with data:', surveyData);
    surveyUtils
      .createSurvey(surveyData)
      .then((res) => {
        if (res.success) {
          setSuccess(true);
        }
      })
      .catch((err) => {
        setError([`Fallo creando la encuesta. Contacte al administrador. (${err.message})`]);
        setDisabled(false);
      });
  };

  const generateGeneralError = (errorList) => {
    const errorRender = [];
    if (errorList) {
      for (let i = 0; i < errorList.length; i++) {
        errorRender.push(
          <li key={i} className="error-signup-general">
            {errorList[i]}
          </li>
        );
      }
    }
    return errorRender;
  };

  return (
    <div>
      <NavBar />
      <div className="auth-wrapper bg-light">
        <div className="auth-inner form-news">
          <form>
            <div className="form-group">
              <label>Descripción</label>
              <input
                type="text"
                className="form-control"
                placeholder="Descripción"
                onChange={handleDescription}
                onBlur={handleDescription}
                disabled={disabled}
              />
              <p className="error-login">{errorDescription}</p>
            </div>
            <div className="form-group">
              <label>Fecha Desde</label>
              <input
                type="date"
                className="form-control"
                onChange={handleDateFrom}
                onBlur={handleDateFrom}
                disabled={disabled}
                value={dateFrom}
              />
              <p className="error-login">{errorDateFrom}</p>
            </div>
            <div className="form-group">
              <label>Fecha Hasta</label>
              <input
                type="date"
                className="form-control"
                onChange={handleDateTo}
                onBlur={handleDateTo}
                disabled={disabled}
                value={dateTo}
              />
              <p className="error-login">{errorDateTo}</p>
            </div>
            <div className="form-group">
              <label>Estado</label>
              <select
                className="form-control"
                onChange={handleStatus}
                onBlur={handleStatus}
                disabled={disabled}
                value={status}
              >
                <option value="">Seleccione estado</option>
                <option value="INACTIVA">INACTIVA</option>
                <option value="ACTIVA">ACTIVA</option>
              </select>
              <p className="error-login">{errorStatus}</p>
            </div>
            <div className="form-group">
              <label>URL (opcional)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Link a la encuesta"
                onChange={handleUrl}
                onBlur={handleUrl}
                disabled={disabled}
                value={url}
              />
              <p className="error-login">{errorUrl}</p>
            </div>
            <button
              type="button"
              className="btn btn-dark btn-block"
              onClick={saveSurvey}
              disabled={disabled}
            >
              Crear Encuesta
            </button>
            <ul className="error-list-general">
              {generateGeneralError(error)}
            </ul>
          </form>
          <div
            className="col-12 success-signup"
            style={{ display: success ? 'block' : 'none' }}
          >
            <Title
              message="¡La encuesta se creó correctamente!"
              theme="success"
            />
            <a
              className="btn btn-dark btn-cart"
              href="/surveys"
              role="button"
            >
              Volver
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyForm;